<script>
  import { beforeNavigate } from '$app/navigation';
  import { store, debounce, Link } from '$client';
  import { page } from '$app/stores';
  import { onMount } from 'svelte';
  const { search: isOpen } = store;

  const TIMEOUT = 250;
  const SHOWN = 12;
  let query = '';
  let searched = [];
  let count = 0;

  const search = debounce(async event => {
    try {
      const data = await fetch('/api/search?search=' + encodeURI(event.target.value));
      const parsed = await data.json();
      const values = Object.values(parsed.searched);
      searched = values.slice(0, SHOWN);
      count = values.length;
    } catch (err) {
      console.log(err);
      store.alert.set(ERR_MESSAGE);
    }
  }, TIMEOUT);

  let mounted = false;
  isOpen.subscribe(v => {
    if (!mounted) return v;
    if (v) document.body.style.overflowY = 'hidden';
    else document.body.style.overflowY = 'auto';
    return v;
  });

  onMount(() => {
    if ($isOpen) document.body.style.overflowY = 'hidden';
    else document.body.style.overflowY = 'auto';
    mounted = true;
    return () => (mounted = false);
  });

  beforeNavigate(() => {
    try {
      document.body.style.overflowY = 'auto';
    } catch {}
    isOpen.set(null);
    query = '';
    count = 0;
  });
</script>

<div id="search-menu" data-open={$isOpen} itemscope itemtype="https://schema.org/WebSite">
  <meta itemprop="url" content={$page.url.origin} />
  <form
    style="box-shadow: 0 0 15px rgb(0 0 0 / 0{query && searched.length != 0 ? '' : '.5'});"
    itemprop="potentialAction"
    itemscope
    itemtype="https://schema.org/SearchAction">
    <meta itemprop="target" content="{$page.url.origin}/poisk?search={'{search_term_string}'}" />
    <input
      itemprop="query-input"
      type="text"
      name="search_term_string"
      bind:value={query}
      on:input={search}
      placeholder="Поиск по сайту" />
    <button
      type="button"
      aria-label="закрыть строку поиска"
      name="закрыть строку поиска"
      on:click={() => isOpen.set(false)}>
      <span></span>
      <span></span>
    </button>
  </form>

  {#if query && searched.length !== 0}
    <nav>
      <ul>
        {#each searched as { url, header, type }}
          <li><Link attributes={{ title: header }} href={url} />{header}<br /><span>{type}</span></li>
        {/each}
      </ul>
      {#if count - SHOWN > 0}
        <Link href="/poisk?search={encodeURI(query)}&page=2"
          >Посмотреть ещё <span>{count - SHOWN}</span> результатов</Link>
      {/if}
    </nav>
  {/if}
</div>

<style lang="scss">
  #search-menu {
    position: fixed;
    top: -200px;
    left: 50%;
    z-index: 10;
    display: flex;
    flex-direction: column;
    gap: 3px;
    align-items: flex-end;
    justify-content: center;
    width: min(750px, 100%);
    transform: translateX(-50%);
    opacity: 0;
    transition:
      top 0.5s,
      opacity 0.5s;
    pointer-events: none;
    will-change: opacity, top;

    &[data-open='true'] {
      top: 80px;
      opacity: 1;
      pointer-events: initial;
    }

    @media only screen and (max-width: 760px) {
      top: 0 !important;
      left: 0;
      align-items: flex-start;
      justify-content: flex-start;
      height: calc(100vh);
      min-height: calc(100vh) !important;
      overflow-y: auto;
      background-color: rgb(55 61 70 / 100%);
      transform: translateX(0);
      transition: all 0s;

      form {
        background-color: rgb(44 51 60);
        border-radius: 0 !important;
        box-shadow: none !important;
      }
    }
  }

  form {
    display: inline-flex;
    gap: 5px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background-color: #373d46;
    border-radius: 5px;
    padding-inline: 24px;

    button {
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      width: 24px;
      height: 20px;

      span {
        width: 100%;
        height: 4px;
        background-color: #22eaac;
      }

      span:first-child {
        transform: translateY(200%) rotate(45deg);
      }

      span:last-child {
        transform: translateY(-195%) rotate(-45deg);
      }
    }

    input {
      z-index: 2;
      width: 100%;
      margin-right: 15px;
      color: #fff;
      background-color: rgb(55 61 70 / 100%);
      border: none;
      padding-block: 15px;

      &::placeholder {
        color: rgb(244 244 244 / 100%);
        opacity: 0.35;
      }
    }

    @media only screen and (max-width: 760px) {
      input {
        background: transparent;
      }
    }
  }

  nav {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    overflow: hidden;
    background-color: rgb(55 61 70 / 100%);
    border-radius: 5px 5px 5px 10px;

    @media only screen and (max-width: 760px) {
      height: 100%;
      max-height: 100%;
      overflow-y: auto;
      border-radius: 0;
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 12px;
      align-items: flex-start;
      width: 100%;
      // padding-inline: 24px;
      padding-block: 20px;
      color: #fff;
      font-size: 14px;
      font-family: Roboto, sans-serif;

      @media only screen and (min-width: 760px) {
        max-height: 300px;
        overflow: hidden auto;
      }

      li {
        position: relative;
        width: 100%;
        border-left: 2px solid rgb(255 255 255 / 45%);
        padding-inline: 24px;
      }

      :global(a) {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      span {
        color: rgb(255 255 255 / 45%);
      }
    }

    :global(> a),
    :global(> div) {
      gap: 10px;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 25px;
      padding: 12px 25px;
      color: #2c333c;
      font-weight: 600;
      font-size: 14px;
      font-family: Vela Sans;
      line-height: 140%;
      white-space: nowrap;
      text-align: center;
      background-color: #22eaac;
      border-radius: 0 0 5px 5px;
      outline: none;
      box-shadow: 0 0 15px rgb(0 0 0 / 5%);

      @media only screen and (max-width: 760px) {
        margin-top: auto;
        border-radius: 0;
      }

      @media only screen and (max-width: 470.98px) {
        padding: 12px 20px;
      }

      @media only screen and (max-width: 350.98px) {
        padding: 12px 16px;
        font-size: 14px;
      }
    }
  }
</style>
